<template>
  <div class="infoWindowHeader">
    <InfoWindowName
      :info-window-name="infoWindowName"
      :link="infoWindowContent.link"
    />
  </div>
  <div class="infoWindowBody">
    <div v-if="!isOverlayContent">
      <DisplayFields :display-fields="infoWindowContent.displayFields" />
    </div>
    <CompGroups
      v-if="infoWindowContent.comps?.length"
      :comps="infoWindowContent.comps"
      :info-window-content="infoWindowContent"
    />

    <InfoWindowSpacer v-if="overlays?.length && infoWindowContent.displayFields.length" />

    <v-progress-circular
      v-if="isLoading"
      indeterminate
    />
    <OverlayRows
      v-if="overlays.length"
      :overlays="overlays"
    />
  </div>
</template>

<script lang="ts">
// Components
import InfoWindowName from '@/components/InfoWindow/sections/Header/InfoWindowName.vue';
import DisplayFields from '@/components/InfoWindow/DisplayFields/DisplayFields.vue';
import CompGroups from '@/components/InfoWindow/DisplayFields/Comps/CompGroups.vue';
import OverlayRows from '@/components/InfoWindow/DisplayFields/OverlayRows/OverlayRows.vue';
import InfoWindowSpacer from '@/components/InfoWindow/InfoWindowSpacer.vue';

// Types
import type {InfoWindowContent} from '@/lib/classes/InfoWindowContent';
import type {Overlay} from '@/services/OverlaysService';

// 3rd party
import {PropType} from 'vue';

export default {
  name: 'NorthpointInfoWindow',
  components: {
    InfoWindowName,
    DisplayFields,
    CompGroups,
    OverlayRows,
    InfoWindowSpacer,
  },
  props: {
    infoWindowContent: {
      type: Object as PropType<InfoWindowContent>,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      overlays: [] as Overlay[],
      isOverlayContent: ['overlay', 'taxOverlay'].includes(this.infoWindowContent.type),
    };
  },
  computed: {
    infoWindowName() {
      return this.getInfoWindowNameValue() ?? '';
    },
  },
  async mounted() {
    this.isLoading = true;

    this.overlays = (await this.infoWindowContent.overlays ?? [])
      .filter((overlay) => overlay.isTaxOverlay === (this.infoWindowContent.type === 'taxOverlay'));

    this.isLoading = false;
  },
  methods: {
    getInfoWindowNameValue() {
      if (!this.isOverlayContent) {
        return this.infoWindowContent.title;
      }

      if (this.overlays.length) {
        return this.overlays[0].parent?.name;
      }

      return null; // Replace this when infoWindowContent can get the project name
    },
  },
};
</script>
